import { Helmet } from 'react-helmet';
import { CreateContainer } from '../components/create.container';
import { useParams } from 'react-router-dom';
import { getItem } from '../../../../../../../shared/local-storage';
import { PageHeader } from '../../../../../../../shared/page-header';
import { SubPageLayout } from '../sub-page-layout';

interface SendReportCreateProps {}

export const SendReportCreate: React.FC<SendReportCreateProps> = () => {
  const applicantUserId = getItem('applicantUserId');
  const params = useParams();

  return (
    <SubPageLayout
      header={
        <PageHeader
          title=""
          subTitle="Send Report Request"
          description=""
        />
      }
    >
      <Helmet>
        <title>Case - Draft</title>
      </Helmet>
      <CreateContainer caseId={params.caseId ?? ''} applicantUserId={applicantUserId ?? ''} />
    </SubPageLayout>
  );
};
